<template>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle1" :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入企业名称" v-model="queryParam.supplier"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="企业编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入企业编码" v-model="queryParam.code"></a-input>
                  </a-form-item>
                </a-col>
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset(12)">重置</a-button>

                  </a-col>
                </span>

              </a-row>

            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <!-- 操作按钮区域 -->
          <!-- table区域-begin -->
          <div>
            <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
              :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
              :pagination="ipagination" :loading="loading"

              @change="handleTableChange" style="word-break: break-all;">
              <span slot="action" slot-scope="text, record">
                <a type="primary" @click="getDetail(record, 2)" :disabled="record.state == 2 || record.state == 3">审核</a>
              </span>
              <template slot="createTime" slot-scope="createTime">
                <span>{{changetime(createTime)}}</span>
              </template>
              <template slot="state" slot-scope="state">
                <a-tag v-if="state === 0" color="orange">待审核</a-tag>
                <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
                <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
                <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
              </template>

            </a-table>
          </div>
          <!-- table区域-end -->
          <!-- 表单区域 -->
          <EnterpriseDetail ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></EnterpriseDetail>
        </a-card>
      </a-col>
    </a-row>
  </template>
  <!-- create ji sheng hua-->
  <script>
  import { campListMixins } from '../mixins/campListMixins'
  import EnterpriseDetail from '../modules/enterpriseDetail'
  import JDate from '@/components/jeecg/JDate'
  import { companyApprovalDetail } from '@/api/api'


  export default {
    name: 'vendorApply',
    mixins: [campListMixins],
    components: {
      JDate,
      EnterpriseDetail
    },
    data() {
      return {
        ipagination: {
          pageSizeOptions: ['10', '20', '30', '100', '200'],
        },
        // 查询条件
        queryParam: {
            licenceType: '2'
        },
        prefixNo: 'LSCK',
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
          offset: 1,
        },
        // 默认列
        columns: [
          { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
          { title: '企业名称', dataIndex: 'supplier',width: 230, render: (text) => text || "--"},
          { title: '企业编码', dataIndex: 'code',  width: 250,render: (text) => text || "--" },
          { title: '统一社会信用代码', dataIndex: 'credit',render: (text) => text || "--"},
          { title: '企业类型', dataIndex: 'type',render: (text) => text || "--"},
          { title: '状态', dataIndex: 'state',align: "center",scopedSlots: { customRender: 'state' } },
          { title: '审核人', dataIndex: 'Approver',render: (text) => text || "--"},
          { title: '审核时间', dataIndex: 'ApprovalTime',render: (text) => text || "--"},
          { title: '企业类型', dataIndex: 'type',render: (text) => text || "--"},
          {
            title: '操作',
            dataIndex: 'action',
            width: 300,
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '/sy/examine/licenceExamine/list',

        },
      }
    },
    computed: {},
    created() {

    },
    methods: {

      changetime(createTime) {
        return createTime.replace('T', ' ')
      },
      //打开详情
      async getDetail(record,num){
        console.log(record,'详细信息=======================')
        let params = {
          examineId : record.uuid,
          licenceType: num
        }
        const res = await companyApprovalDetail(params)
        if (res.code == 200 && res.success == true) {
            console.log(res)
            this.$message.success(res.message)
            this.$refs.modalDetail.initShow(res,num,record.uuid)
        } else {
            this.$message.error(res.message)
        }
        // this.$refs.modalDetail.initShow(res)
      },
      modalFormOk(){
        this.loadData(1)
      },
      modalFormClose(){
        this.loadData(1)
      },
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  /deep/.ant-table-row-cell-break-word:empty:after {
    content: '--';
  }
  /deep/.ant-table-header{
    overflow-y: hidden!important;
  }
  </style>